import React, { useState } from 'react'
import clsx from 'clsx'
import './navbar.scss'
import whiteLogo from '../../images/white-logo.svg'
import whiteMobileLogo from '../../images/white-mobile-logo.svg'
import blackLogo from '../../images/black-logo.svg'
import blackMobileLogo from '../../images/black-mobile-logo.svg'
import { Link } from 'gatsby'
import Button from '../Button/Button'
import Icon from '../Icon/Icon'
import { hideBodyScroll, showBodyScroll } from '../../utils/helpers'
export const Navbar = ({ otherClasses, toggleFunc, darkNav }) => {
  const [scroll, setScroll] = useState(false)

  const changeBackground = () => {
    if (typeof window !== 'undefined' && window.scrollY >= 80) {
      setScroll(true)
    } else {
      setScroll(false)
    }
  }
  typeof window !== 'undefined' &&
    window.addEventListener('scroll', changeBackground)

  const [state, setState] = useState(false)
  const stateFunc = (elm) => {
    setState(!elm)
  }

  if (state) {
    hideBodyScroll()
  } else {
    showBodyScroll()
  }

  const navbarClasses = clsx(
    otherClasses,
    'w-full fixed top-0 left-0 z-20',
    darkNav ? 'bg-[#181818]' : 'lg:bg-transparent bg-[#181818]',
    scroll && '!bg-white'
  )

  return (
    <nav className={navbarClasses} id="navbar" data-testid="navbar">
      <div className="max-w-[1512px] mx-auto w-full px-4 lg:px-20 py-3 lg:py-0 xl:px-[156px] relative flex items-center justify-between">
        <a href="tel:(619) 359-4107" className="lg:hidden">
          <Icon
            icon={clsx(scroll ? 'nav-phone-icon' : 'nav-phone-white')}
            iconHeight={24}
            iconWidth={24}
          />
        </a>
        <Link
          to="/"
          className="lg:absolute lg:translate-x-[-50%] lg:left-2/4 lg:top-2/4 lg:translate-y-[-50%]"
        >
          {scroll ? (
            <>
              <img
                src={blackLogo}
                alt="logo-white"
                className="w-[123px] h-[56px]"
              />
              {/* <img
                src={blackMobileLogo}
                alt="logo-white"
                className="w-[87.9px] h-[40px] lg:hidden"
              /> */}
            </>
          ) : (
            <>
              <img
                src={whiteLogo}
                alt="logo-white"
                className="w-[132px] h-20"
              />
              {/* <img
                src={whiteMobileLogo}
                alt="logo-white"
                className="w-[87.9px] h-[40px] lg:hidden"
              /> */}
            </>
          )}
        </Link>
        <div
          className={clsx(
            'absolute top-[64px] left-0 py-[60px] overflow-auto gap-[60px] lg:overflow-visible lg:py-0 lg:static lg:top-auto lg:left-auto justify-between flex-col items-center lg:items-start lg:justify-start mobile_nav_container bg-[#222] lg:bg-transparent w-full lg:w-w-full',
            state ? 'flex mt-0' : ' hidden lg:block',
            scroll ? 'top-[80px]' : 'top-[104px]'
          )}
        >
          <div className="w-full flex flex-col gap-8 lg:flex-row lg:items-center lg:justify-between">
            <div>
              <ul className="flex items-center flex-col lg:flex-row gap-8">
                <li
                  className={clsx(
                    'relative group flex flex-col lg:flex-row items-center gap-8',
                    scroll ? 'lg:h-[72px]' : 'lg:h-[120px]'
                  )}
                >
                  <Link
                    to="/tattoo-styles/"
                    className={clsx(
                      'font-Gentium-Plus font-bold leading-6 text-base tracking-[0.48px] hidden lg:block',
                      scroll ? 'text-gray-900' : 'text-white uppercase'
                    )}
                  >
                    Tattoos
                  </Link>
                  <button className="text-[30px] font-Gentium-Plus font-bold text-primary_biege_600 text-center lg:hidden">
                    Tattoos
                  </button>
                  <ul
                    className={clsx(
                      'lg:absolute group-hover:flex lg:px-6 lg:py-3 hidden flex-col items-center lg:items-start gap-5 lg:gap-2 lg:min-w-[160px] lg:bg-primary_biege_600 rounded-[4px]',
                      scroll ? 'top-[72px]' : 'top-[96px]'
                    )}
                  >
                    <Link
                      to="/tattoo-styles/"
                      className="lg:text-left text-center text-[#A8976B] lg:text-gray-900 lg:text-base text-[18px] leading-[28px] font-bold lg:font-normal lg:leading-6 font-Gentium-Plus hover:text-primary_purple_600 lg:hidden"
                    >
                      Tattoos
                    </Link>
                    <Link
                      to="/tattoo-artists/"
                      className="lg:text-left text-center text-[#A8976B] lg:text-gray-900 lg:text-base text-[18px] leading-[28px] font-bold lg:font-normal lg:leading-6 font-Gentium-Plus hover:text-primary_purple_600"
                    >
                      Artists
                    </Link>
                    <Link
                      to="/tattoo-aftercare/"
                      className="lg:text-left text-center text-[#A8976B] lg:text-gray-900 lg:text-base text-[18px] leading-[28px] font-bold lg:font-normal lg:leading-6 font-Gentium-Plus hover:text-primary_purple_600"
                    >
                      Tattoo Aftercare
                    </Link>
                  </ul>
                </li>
                <li
                  className={clsx(
                    'relative group flex flex-col lg:flex-row items-center gap-8',
                    scroll ? 'lg:h-[72px]' : 'lg:h-[120px] '
                  )}
                >
                  <Link
                    to="/piercing-services/"
                    className={clsx(
                      'font-Gentium-Plus font-bold leading-6 text-base tracking-[0.48px] hidden lg:block',
                      scroll ? 'text-gray-900' : 'text-white uppercase'
                    )}
                  >
                    Piercing
                  </Link>
                  <button className="text-[30px] font-Gentium-Plus font-bold text-primary_biege_600 text-center lg:hidden">
                    Piercing
                  </button>
                  <ul
                    className={clsx(
                      'lg:absolute group-hover:flex lg:px-6 lg:py-3 hidden flex-col items-center lg:items-start gap-5 lg:gap-2 lg:min-w-[170px] lg:bg-primary_biege_600 rounded-[4px]',
                      scroll ? 'top-[72px]' : 'top-[96px]'
                    )}
                  >
                    <Link
                      to="/piercing-services/"
                      className="lg:text-left text-center text-[#A8976B] lg:text-gray-900 lg:text-base text-[18px] leading-[28px] font-bold lg:font-normal lg:leading-6 font-Gentium-Plus hover:text-primary_purple_600 lg:hidden"
                    >
                      Piercing
                    </Link>
                    <Link
                      to="/piercers/"
                      className="lg:text-left text-center text-[#A8976B] lg:text-gray-900 lg:text-base text-[18px] leading-[28px] font-bold lg:font-normal lg:leading-6 font-Gentium-Plus hover:text-primary_purple_600"
                    >
                      Body Piercers
                    </Link>
                    <Link
                      to="/piercing-aftercare/"
                      className="lg:text-left text-center text-[#A8976B] lg:text-gray-900 lg:text-base text-[18px] leading-[28px] font-bold lg:font-normal lg:leading-6 font-Gentium-Plus hover:text-primary_purple_600"
                    >
                      Piercing Aftercare
                    </Link>
                  </ul>
                </li>
                <li
                  className={clsx(
                    'relative group flex flex-col lg:flex-row items-center gap-8',
                    scroll ? 'lg:h-[72px]' : 'lg:h-[120px] '
                  )}
                >
                  <Link
                    to="/bay-ink-locations/"
                    className={clsx(
                      'font-Gentium-Plus font-bold leading-6 text-base tracking-[0.48px] hidden lg:block',
                      scroll ? 'text-gray-900' : 'text-white uppercase'
                    )}
                  >
                    Studios
                  </Link>
                  <button className="text-[30px] font-Gentium-Plus font-bold text-primary_biege_600 text-center lg:hidden">
                    Studios
                  </button>
                  <ul
                    className={clsx(
                      'lg:absolute group-hover:flex lg:px-6 lg:py-3 hidden flex-col items-center lg:items-start gap-5 lg:gap-2 lg:min-w-[120px] lg:bg-primary_biege_600 rounded-[4px]',
                      scroll ? 'top-[72px]' : 'top-[96px]'
                    )}
                  >
                    <Link
                      to="/bay-ink-locations/"
                      className="lg:text-left text-center text-[#A8976B] lg:text-gray-900 lg:text-base text-[18px] leading-[28px] font-bold lg:font-normal lg:leading-6 font-Gentium-Plus hover:text-primary_purple_600 lg:hidden"
                    >
                      Studios
                    </Link>
                    <Link
                      to="/bay-park-tattoo-shop/"
                      className="lg:text-left text-center text-[#A8976B] lg:text-gray-900 lg:text-base text-[18px] leading-[28px] font-bold lg:font-normal lg:leading-6 font-Gentium-Plus hover:text-primary_purple_600"
                    >
                      Bay Park
                    </Link>
                    <Link
                      to="/hillcrest-tattoo-shop/"
                      className="lg:text-left text-center text-[#A8976B] lg:text-gray-900 lg:text-base text-[18px] leading-[28px] font-bold lg:font-normal lg:leading-6 font-Gentium-Plus hover:text-primary_purple_600"
                    >
                      Hillcrest
                    </Link>
                    <Link
                      to="/la-jolla-tattoo-shop/"
                      className="lg:text-left text-center text-[#A8976B] lg:text-gray-900 lg:text-base text-[18px] leading-[28px] font-bold lg:font-normal lg:leading-6 font-Gentium-Plus hover:text-primary_purple_600"
                    >
                      La Jolla
                    </Link>
                  </ul>
                </li>
              </ul>
            </div>
            <div className="flex items-center flex-col lg:flex-row gap-8">
              <ul className="flex items-center flex-col lg:flex-row gap-8">
                <li
                  className={clsx(
                    'relative group flex flex-col lg:flex-row items-center gap-8',
                    scroll ? 'lg:h-[72px]' : 'lg:h-[120px] '
                  )}
                >
                  <Link
                    to="/about-bay-ink-tattoo/"
                    className={clsx(
                      'font-Gentium-Plus font-bold leading-6 cursor-pointer text-base tracking-[0.48px] hidden lg:block',
                      scroll ? 'text-gray-900' : 'text-white uppercase'
                    )}
                  >
                    About
                  </Link>
                  <button className="text-[30px] font-Gentium-Plus font-bold text-primary_biege_600 text-center lg:hidden">
                    About
                  </button>
                  <ul
                    className={clsx(
                      'lg:absolute group-hover:flex lg:px-6 lg:py-3 hidden flex-col items-center lg:items-start gap-5 lg:gap-2 lg:min-w-[150px] lg:bg-primary_biege_600 rounded-[4px]',
                      scroll ? 'top-[72px]' : 'top-[96px]'
                    )}
                  >
                    <Link
                      to="/about-bay-ink-tattoo/"
                      className="lg:text-left text-center text-[#A8976B] lg:text-gray-900 lg:text-base text-[18px] leading-[28px] font-bold lg:font-normal lg:leading-6 font-Gentium-Plus hover:text-primary_purple_600 lg:hidden"
                    >
                      About Us
                    </Link>
                    <Link
                      to="/bay-ink-testimonials/"
                      className="lg:text-left text-center text-[#A8976B] lg:text-gray-900 lg:text-base text-[18px] leading-[28px] font-bold lg:font-normal lg:leading-6 font-Gentium-Plus hover:text-primary_purple_600"
                    >
                      Testimonials
                    </Link>
                    <Link
                      to="/faq/"
                      className="lg:text-left text-center text-[#A8976B] lg:text-gray-900 lg:text-base text-[18px] leading-[28px] font-bold lg:font-normal lg:leading-6 font-Gentium-Plus hover:text-primary_purple_600"
                    >
                      FAQ
                    </Link>
                    <Link
                      to="/tattoo-piercing-blog/"
                      className="lg:text-left text-center text-[#A8976B] lg:text-gray-900 lg:text-base text-[18px] leading-[28px] font-bold lg:font-normal lg:leading-6 font-Gentium-Plus hover:text-primary_purple_600"
                    >
                      Blog
                    </Link>
                  </ul>
                </li>
                <li
                  className={clsx(
                    'relative group flex flex-col lg:flex-row items-center gap-8',
                    scroll ? 'lg:h-[72px]' : 'lg:h-[120px] '
                  )}
                >
                  <Link
                    to="/buy-gift-card/"
                    className={clsx(
                      'font-Gentium-Plus font-bold leading-6 cursor-pointer text-base tracking-[0.48px] hidden lg:block',
                      scroll ? 'text-gray-900' : 'text-white uppercase'
                    )}
                  >
                    Gift Card
                  </Link>
                  <button className="text-[30px] font-Gentium-Plus font-bold text-primary_biege_600 text-center lg:hidden">
                    Gift Card
                  </button>
                </li>
                <li
                  className={clsx(
                    'relative group flex flex-col lg:flex-row items-center gap-8',
                    scroll ? 'lg:h-[72px]' : 'lg:h-[120px] '
                  )}
                >
                  <button
                    onClick={() => toggleFunc('Contact Us')}
                    className={clsx(
                      'font-Gentium-Plus font-bold leading-6 text-base tracking-[0.48px] hidden lg:block',
                      scroll ? 'text-gray-900' : 'text-white uppercase'
                    )}
                  >
                    Contact
                  </button>
                  <button
                    onClick={() => toggleFunc('Contact Us')}
                    className="text-[30px] font-Gentium-Plus font-bold text-primary_biege_600 text-center lg:hidden"
                  >
                    Contact
                  </button>
                </li>
              </ul>
              <Link to="/book-an-appointment/">
                <Button variant="primary" label="Book" otherClasses="" />
              </Link>
            </div>
          </div>
        </div>
        <button onClick={() => stateFunc(state)} className="lg:hidden">
          {scroll ? (
            <Icon
              icon={clsx(state ? 'nav-close-black' : 'nav-hamburger')}
              iconHeight={state ? 20 : 24}
              iconWidth={24}
            />
          ) : (
            <Icon
              icon={clsx(state ? 'nav-cancel-icon' : 'nav-hamburger-white')}
              iconHeight={state ? 20 : 24}
              iconWidth={24}
            />
          )}
        </button>
      </div>
    </nav>
  )
}

export default Navbar
